import React from 'react';
import { withFormik, Form, Field } from 'formik'


const PurchaseOrderNumberFilter = ({ values, errors, touched, setFieldValue, setFieldTouched }) => {
  const onChange = (name, val) => {
    setFieldValue(name, val)
  }

  return (
    <Form>
      <br />
      <div className='idsFilter'>
        <div className='row fullWidth'>
          <div className='medium-12 columns'>
            <label>Order Purchase Number
              <Field
                className={'inputStringField'}
                name="purchaseOrderNumber"
                type="string"
                value={values.purchaseOrderNumber}
                onChange={e => onChange('purchaseOrderNumber', e.target.value)}
                onBlur={setFieldTouched}
                error={errors.purchaseOrderNumber}
                placeholder="Enter purchase order number"
              />
              {errors.purchaseOrderNumber && touched.purchaseOrderNumber && <small className="error">{errors.purchaseOrderNumber}</small>}
            </label>
          </div>
        </div>
        <br />
        <div className='row fullWidth'>
          <div className='medium-12 columns'>
            <button className='button right'>Submit</button>
          </div>
        </div>
      </div>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues(props) {
    const { purchaseOrderNumber } = props.currentParams
    return {
      purchaseOrderNumber
    }
  },

  handleSubmit(values, { props }) {
    const { purchaseOrderNumber } = values
    const params = {
      purchaseOrderNumber
    }

    props.onSubmit(params)
  }

})(PurchaseOrderNumberFilter)
